import React from 'react';
import {Link} from 'react-router-dom';
import logoUK from '../../../assets/img/imperial_tobacco_logo-white.png';
import logoIreland from '../../../assets/img/john_player_ignite_white.png';
import {createObjectFromStack, currentStack} from '../../../data/stack';

const getLogoFromStack = stack => (
  createObjectFromStack(
    {src: logoUK},
    {
      src: logoIreland,
      style: {
        width: '100%'
      }
    }
  )[stack]
);

export default () => (
  <Link className="footer-image-link" to="/">
    <img {...getLogoFromStack(currentStack)}/>
  </Link>
);



// WEBPACK FOOTER //
// ./src/components/layout/navbar/navbar-footer-logo.jsx